import React, {useState} from 'react';
import { ChargingStation } from './ChargingStation';
import { ChargingStation as ChargingStationType } from 'models/charging/agreement';
import { isNotNullOrUndefined } from 'common/data-util';

interface ChargingStationListProps {
  stations?: ChargingStationType[];
}

export function ChargingStationList({
  stations,
} : ChargingStationListProps ) {
  const [expand, setExpand] = useState(false);

  const stationsLen = stations?.length ?? 0;
  const stationsLimit = expand ? stationsLen : 3

  if(!stations?.length) return null;

  const hasNozzleCount = stations.some(station => isNotNullOrUndefined(station.nozzleCount));

  return (
    <>
      <div className="u-hr"></div>
      <div className="row ml-lg-3 mb-3">
        <div className="col">
          <strong className="u-fs-20">{stations.length > 1 ? 'Laadimisjaamad' : 'Laadimisjaam'}</strong>
        </div>
      </div>
      <div>
        <div className="row px-2 px-lg-3 mx-0 mb-2">
          <div className="d-none col-lg d-lg-flex flex-row text-gray-700">SEERIA NR</div>
          <div className="d-none col-lg d-lg-flex flex-row text-gray-700">MUDEL</div>
          {
            hasNozzleCount ? (
              <div className="d-none col-lg d-lg-flex flex-row text-gray-700">OTSIKUTE ARV</div>
            ) : null
          }
        </div>
        {stations?.slice(0, stationsLimit).map(station => (
          <ChargingStation 
            key={station.id}
            {...station} 
            model={station.model.name}
          />
        ))}
        {(stationsLen > 3) && (
          <div
            className="cursor-pointer u-fs-16 row align-items-center justify-content-center justify-content-lg-start ml-lg-3 mt-3"
            onClick={() => setExpand(!expand)}
          >
            <i className={expand ? "icon__arrow-up" : "icon__arrow-down"}></i>
            <strong className="text-right text-lg-left ml-2">{expand ? "Näita vähem" : "Näita rohkem"}</strong>
          </div>
        )}
      </div>
    </>
  );
}